import { Theme } from '@mui/material/styles';

export const action = (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginTop: theme.spacing(4),

    '.MuiButton-root': {
        backgroundColor: 'primary.main',
        fontSize: 14,
        fontWeight: 600,
        minWidth: '120px',
        minHeight: '35px',
    }
}) as const;

export const error = (theme: Theme) => ({
    color: 'error.main',
    marginTop: theme.spacing(1),
}) as const;

export const disabled = (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginTop: theme.spacing(4),

    '.MuiButton-root': {
        backgroundColor: 'doveGray.main',
        fontSize: 14,
        cursor: 'default',
        PointerEvent: 'none',
        fontWeight: 600,
        minWidth: '120px',
        minHeight: '35px',
    }
}) as const;
